import { useSnackbar } from "components/SnackbarContext/SnackbarContext";
import { useCallback, useState } from "react";

export const useMutationWithRefetch = <
  TMutation extends (vars: unknown) => Promise<unknown>
>({
  mutation,
  refetch,
  onError
}: {
  mutation: TMutation;
  refetch: (data?: unknown) => Promise<unknown>;
  onError?: (error: unknown) => void;
}) => {
  type TVariables = Parameters<TMutation>[0];

  const { showErrorSnack } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const run = useCallback(
    async (vars: TVariables) => {
      try {
        setIsLoading(true);
        const mutationResult = await mutation(vars);

        await refetch();

        return mutationResult;
      } catch (error) {
        console.error(error);
        onError?.(error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [mutation, refetch, onError, showErrorSnack]
  );

  return { run, isLoading };
};
